import config from '@utils/config';
import request from '@utils/request';

// 下线盘口数据
export const offlineSymbols = () => {
  const URL = config.api.host_api_v1 + config.api.cfd.offlineSymbols;
  return request.get.call({}, URL);
}
